let type = 1
if (window.location.href.indexOf("cashier.greencampus.me") > -1 || process.env.NODE_ENV=='development') {
    type = 0
}
export default type //1是正式服 0是测试服



// WEBPACK FOOTER //
// ./src/api/isLocal.js